var _path, _circle;
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
const SvgLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M12.5 6c0 1.904-1.155 3.873-2.39 5.417A20 20 0 0 1 8 13.667a20.283 20.283 0 0 1-2.11-2.25C4.655 9.873 3.5 7.904 3.5 6a4.5 4.5 0 0 1 9 0Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 5.958,
  r: 0.5,
  stroke: "currentColor"
})));
export default SvgLocation;